import axios from 'axios';

export const HTTP = axios.create({
  baseURL: '/gateway',
});

let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

HTTP.interceptors.response.use(function (response) {
  return response;
}, function(err) {
  
  if(isUnauthorizedError(err)) {
    if(unauthorizedHandler !== null) {
      unauthorizedHandler();
    }
  }
  return Promise.reject(err);
});

function isUnauthorizedError(err) {
  if(!('response' in err)) {
    return false;
  }

  const response = err.response;
  if(response === undefined || response === null) {
    return false;
  }

  if(!('status' in err)) {
    return false;
  }

  const status = response.status;
  if(status === undefined || status === null) {
    return false;
  }
  
  const STATUS_UNAUTHORIZED = 401;
  return status === STATUS_UNAUTHORIZED;
}
